/** Root-mean-square of a Float32 PCM buffer in [-1, 1]. Inline-summed
 *  so we don't pay a function-call per frame on the audio thread. */
export function computeRms(buf: Float32Array): number {
  let sum = 0;
  for (const x of buf) {
    sum += x * x;
  }
  return Math.sqrt(sum / buf.length);
}

/** Quantize a level (0–1) into 50 buckets (0.02 steps), so a meter
 *  updates only when the displayed bucket changes — at 20 Hz, a quiet
 *  room becomes ~0 React commits/sec instead of 20/sec. */
export function quantizeInputLevel(rms: number): number {
  return Math.round(rms * 50) / 50;
}
